const editorTextHighlightUI = () => {
    ( function ( wp ) {
    const { registerFormatType, toggleFormat } = wp.richText;
    const { RichTextToolbarButton } = wp.blockEditor;
    const { createElement: el } = wp.element;

    // Register the format only if it hasn't already been registered
    if(wp.data.select('core/rich-text').getFormatType("td/highlight")) return;
    
    registerFormatType("td/highlight", {
        title: "Highlight",
        tagName: "span",
        className: "is-gradient-highlight",
        edit({ isActive, value, onChange }) {
        return el(RichTextToolbarButton, {
            icon: "edit", // pick another dashicon if you want
            title: "Gradient Highlight",
            onClick: () => onChange(toggleFormat(value, { type: "td/highlight" })),
            isActive,
        });
        },
    });
    })(window.wp);
}

const editorTextBlurAnimationUI = () => {
    ( function ( wp ) {
    const { registerFormatType, toggleFormat } = wp.richText;
    const { RichTextToolbarButton } = wp.blockEditor;
    const { createElement: el } = wp.element;

    // Register the format only if it hasn't already been registered
    if(wp.data.select('core/rich-text').getFormatType("td/blur-animation")) return;
    
    registerFormatType("td/blur-animation", {
        title: "Blur Animation",
        tagName: "span",
        className: "is-blur-animation",
        edit({ isActive, value, onChange }) {
        return el(RichTextToolbarButton, {
            icon: "edit", // pick another dashicon if you want
            title: "Blur Animation",
            onClick: () => onChange(toggleFormat(value, { type: "td/blur-animation" })),
            isActive,
        });
        },
    });
    })(window.wp);
}

export default InitEditorTextDecorators = () => {
    editorTextHighlightUI();
    editorTextBlurAnimationUI();
}